<div (click)="dismiss.emit(false)">
	<app-dialog-title [state]="state"></app-dialog-title>
	<div class="duration-bar" *ngIf="durationMilliSeconds ? true : false"></div>
	<p class="message">{{ message }}</p>
	<button
		*ngIf="showConfirmButton"
		mat-flat-button
		class="btn-alarm btn-confirm"
		(click)="$event.stopPropagation(); dismiss.emit(true)"
	>
		{{ 'ROOT.STRINGS.MORE_INFO' | translate }}
	</button>
</div>
